import React, { useEffect, useRef, useState,useContext } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import "./details.scss";
import logo_mt from "../../../../assets/images/logo_mt.jpeg";
import logodntt from "../../../../assets/images/logoDNTT.jpg";
import branding from "../../../../assets/images/branding.png";
import simandou from "../../../../assets/images/simandou2040.png";
import { useNavigate, useParams } from 'react-router-dom';
import Api from '../../../../services/Api';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../../../recoil/atoms/loadingAtom';
import Erreurs from '../../../../components/Erreurs/Erreurs';
import { BsFillExclamationTriangleFill, BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import Swal from 'sweetalert2';
import { toast } from 'react-hot-toast';
import DocumentTitle from '../../../../components/DocumentTitle/DocumentTitle';
import { UserContext } from '../../../../services/Context/Context';


const Details = () => {
  const componentRef = useRef();
  const { invoice_id, chassis_id } = useParams();
  const api = new Api();
  const [paiements, setPaiements] = useState([]); // Changed to plural since it's an array
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useRecoilState(loadingState);
  const data = useContext(UserContext);

  const [erreurs, setErreurs] = useState([]);
  const baseURL = process.env.REACT_APP_URL.replace('api/','') + 'storage/'; 
  const navigate = useNavigate();
  const [isPrinted, setIsPrinted] = useState(false);
  
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @page {
        size: A4;
        margin: 0;
      }
      @media print {
        body, html {
          width: 210mm;
          height: 297mm;
          margin: 0 !important;
          padding: 0 !important;
        }
        .print-btn, .nav-buttons {
          display: none !important;
        }
        * {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
      }
    `,
    onAfterPrint: () => {
       Swal.fire({
        title: 'Impression terminée',
        text: "L'impression s'est il bien effectuée ?",
        icon: 'success',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
       }).then((result) => {
        if(result.isConfirmed){
            api.apiData("post",`/paiement/apc/print?chassis=${currentPaiement.numeroChassis}&groupID=${invoice_id}`).then((response) => {
               if(response.status === 200){
                 toast.success("Impression effectuée avec succès");
                 handleNext();
                 setIsPrinted(true);
               }
            });
        }
        else{
          setIsPrinted(false);
        }
       });
    }
  });

  const getapc = async () => {
    try {
      setIsLoading(true);
      setErreurs([]); 

      const response = await api.apiData("get", `/paiement/apc/invoice?invoice_id=${invoice_id}`);
      //console.log(response);

      if (response.status === 200) {
        setPaiements(response.data);
        // Find the index of the current ID in the array
        if( response.data.length > 0 ){
          const initialIndex = response.data.findIndex(item => item.numeroChassis === (chassis_id || response.data[0].numeroChassis));
          setCurrentIndex(initialIndex >= 0 ? initialIndex : 0);
        }
      } else {
        setErreurs(response.errors);
      }
    } catch(e) {
      console.error(e);
    } finally {
      setIsLoading(false);  
    }
  }

  useEffect(() => {
    getapc();
  }, [invoice_id, chassis_id]);

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      navigate(`/apc/attestation/print/${invoice_id}/${paiements[currentIndex - 1].numeroChassis}`);
      setIsPrinted(false);
    }
  };

  const handleNext = () => {
    if (currentIndex < paiements.length - 1) {
      setCurrentIndex(currentIndex + 1);
      navigate(`/apc/attestation/print/${invoice_id}/${paiements[currentIndex + 1].numeroChassis}`);
      setIsPrinted(false);
    }
  };

  const currentPaiement = paiements[currentIndex];
  console.log(currentPaiement);

  return (
    <div className={`${(paiements.length === 0) ? "_payment " : ""}page`}> 
      <DocumentTitle title={`AEP-${currentPaiement?.reference}`} />
      {paiements.length > 0 ? (
        <div className="document-container">
          <div>
            <Erreurs validation={erreurs} />
            <div className='btn-group'>
              <button className="print-btn" onClick={handlePrint}>
                Imprimer
              </button>
              {(data?.user && data?.user?.username) &&
                <button className='secondary' onClick={() => navigate("/apc/attestation/nouvelle")}>
                 Nouveau
              </button>}
            </div>
            
            {/* Navigation buttons */}
            <div className="nav-buttons">
              <button 
                onClick={handlePrevious} 
                disabled={currentIndex === 0}
                className="nav-button"
              >
                <BsChevronLeft /> Précédent
              </button>
              <span>
                {currentIndex + 1} / {paiements.length}
              </span>
              <button 
                onClick={handleNext} 
                disabled={currentIndex === paiements.length - 1}
                className="nav-button"
              >
                Suivant <BsChevronRight />
              </button>
            </div>
            
            <div className="autorisation-page" ref={componentRef}>
              {/* En-tête officiel */}
               {( currentPaiement.printeCount > 0 || isPrinted ) &&
                <div className="watermark-overlay">
                   Duplicata
               </div>}
              <header className="document-header">
                <div className="flag-colors">
                  <div className="red"></div>
                  <div className="yellow"></div>
                  <div className="green"></div>
                </div>
                <div className='logo_left'> 
                  <img src={logo_mt} alt='logo mt'/>
                </div>
                <h1>REPUBLIQUE DE GUINEE</h1>
                <p className="motto">Travail – Justice - Solidarité</p>
                <div className='ministere'>
                  <h2>MINISTERE DES TRANSPORTS</h2>
                  <h4>Direction Nationale des Transports Terrestres</h4>
                </div>
              
                <div className='logo_right'>
                  <img src={logodntt} alt='logo_embleme'/>
                </div>
                <div className="divider"></div>
                
                <h3>Attestation d'Enregistrement Primaire (AEP)</h3>
              </header>

              {/* Section demandeur */}
              <section className="applicant-section">
                <div className='header'>
                  <div className='type_utilisation'>
                    <p><strong>Demandeur :</strong> <span style={{ textTransform:'capitalize'}}>{ currentPaiement?.typeDemandeur }</span></p>
                    <p><strong>Type Autorisation :</strong><span style={{ textTransform:'capitalize'}}>{ currentPaiement.typeAutorisation }</span> </p>
                  </div>
                  <div className='validite'>
                    <p><strong>Réf : </strong>{ currentPaiement.groupID }</p>
                    <p><strong>Valable jusqu'au : </strong> <span style={{ textTransform:'capitalize'}}> { moment(currentPaiement.dateExpiration).format("DD MMMM YYYY") } </span> </p>
                  </div>
                </div>   
                {/* <table className="applicant-table">
                  <thead>
                    <tr>
                      <th>Prenom et Nom</th> 
                      <th>Adresse</th>
                      <th>Téléphone</th>
                      <th>Nina</th>
                      {currentPaiement.typeDemandeur !== "particulier" && <th>Nom de la structure</th>}
                      {currentPaiement.typeDemandeur !== "particulier" && <th>RCCM</th>}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{ currentPaiement.fullName }</td>
                      <td>{ currentPaiement.adresse || "Non fournie"}</td>
                      <td>{ currentPaiement.telephone }</td>
                      <td>{ currentPaiement.nina || "Non fournie" }</td>
                      {currentPaiement.typeDemandeur !== "particulier" && <td>{ currentPaiement.denominationSociete }</td>}
                      {currentPaiement.typeDemandeur !== "particulier" && <td>{ currentPaiement.rccm }</td>}
                    </tr>
                  </tbody>
                </table> */}
              </section>
              <section className='demandeur-section'>

                 <p>Information sur le demandeur</p>
                 <table className="demandeur-table">
                   <tbody>
                     <tr>
                       <th>N°Identification Nationale</th>
                       <td>{ currentPaiement.nina }</td>
                     </tr>
                     <tr>
                       <th>Prénom et Nom</th>
                       <td>{ currentPaiement.fullName }</td>
                     </tr>
                     <tr>
                       <th>Téléphone</th>
                       <td>{ currentPaiement.telephone }</td>
                     </tr>
                     <tr>
                       <th>Email</th>
                       <td>{ currentPaiement.email || "N/A" }</td>
                     </tr>
                     {(currentPaiement.typeDemandeur === 'concessionnaire' || currentPaiement.typeDemandeur === "constructeur") && (
                       <>
                         <tr>
                           <th>Nom de la structure</th>
                           <td>{ currentPaiement.denominationSociete }</td>
                         </tr>
                         <tr>
                           <th>Adresse</th>
                           <td>{ currentPaiement.adresse }</td>
                         </tr>
                         {/* <tr>
                           <th>RCCM</th>
                           <td>{ currentPaiement.rccm || "N/A" }</td>
                         </tr> */}
                       </>
                     )}
                   </tbody>
                 </table>

              </section>
              <section className='vehicule-section'>
                 <p>Information sur le véhicule</p>
                 <table className="vehicule-table">
                   <tbody>
                     <tr>
                       <th>N°Chassis</th>
                       <td>{ currentPaiement.numeroChassis }</td>
                     </tr>
                     <tr>
                       <th>Catégorie</th>
                       <td>{ currentPaiement.categorie }</td>
                     </tr>
                     <tr>
                       <th>Marque</th>
                       <td>{ currentPaiement.marqueName }</td>
                     </tr>
                     <tr>
                       <th>Modèle</th>
                       <td>{ currentPaiement.modeleName }</td>
                     </tr>
                     <tr>
                       <th>PTAC (kg)</th>
                       <td>{ currentPaiement.ptac }</td>
                     </tr>
                     <tr>
                       <th>Poids à vide (kg)</th>
                       <td>{ currentPaiement.poidsAVide }</td>
                     </tr>
                     <tr>
                       <th>Puissance fiscale (CV)</th>
                       <td>{ currentPaiement.puissanceFiscale }</td>
                     </tr>
                     <tr>
                       <th>Poids total autorisé (kg)</th>
                       <td>{ currentPaiement.poidsTotalRoulant }</td>
                     </tr>
                     <tr>
                       <th>Couleur</th>
                       <td>{ currentPaiement.couleur === 'autre' ? currentPaiement.couleurAutre.charAt(0).toUpperCase() + currentPaiement.couleurAutre.slice(1) : currentPaiement.couleur.charAt(0).toUpperCase() + currentPaiement.couleur.slice(1) }</td>
                     </tr>
                     <tr>
                       <th>Date Première Circulation</th>
                       <td>{ moment(currentPaiement.dateMiseCirculation).format("DD/MM/YYYY") }</td>
                     </tr>
                   </tbody>
                 </table>
              </section>  
              {/* Section véhicule */}
              {/* <section className="vehicle-section">
                <h4>Information sur le Véhicule</h4>
                <table className="vehicle-table">
                  <thead>
                    <tr>
                      <th>Destination Finale</th>
                      <th>Pays d'origine</th>
                      <th>Categorie</th>
                      <th>Marque</th>
                      <th>Modèle</th>
                      <th>N°Chassis</th>
                      <th>PTAC(kg)</th>
                      <th>Date Prémière Circulation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{ currentPaiement.paysDestination }</td>
                      <td>{ currentPaiement.paysProvenance }</td>
                      <td>{ currentPaiement.categorie }</td>
                      <td>{ currentPaiement.marque }</td>
                      <td>{ currentPaiement.modele }</td>
                      <td>{ currentPaiement.numeroChassis }</td>
                      <td>{ currentPaiement.ptac }</td>
                      <td>{ moment(currentPaiement.dateMiseCirculation).format("DD/MM/YYYY") }</td>
                    </tr>
                  </tbody>
                </table>
              </section> */}

              {/* Section validité */}
              <section className="validity-section">
                <h4>Note Importante : </h4>
                <p>
                  Ce document vous autorise temporairement à circuler jusqu'au centre d'immatriculation le plus proche afin d'obtenir votre certificat d'immatriculation. Il ne remplace en aucun cas le certificat d'immatriculation (carte grise) et doit toujours être conservé dans le véhicule jusqu'à l'émission de la carte grise. 
                </p>
                {/* <p>
                  Lors de la demande d'immatriculation, ce document doit obligatoirement être présenté, accompagné des pièces justificatives et de tous les documents requis pour l'immatriculation du véhicule en République de Guinée.
                </p> */}
              </section>
              
              {/* Conteneur pour directeur et footer pour éviter les sauts de page */}
              <div className="footer-container">
                <div className='directeur'>
                  <p>Le Directeur de la DNTT</p>
                  <p>Fait à Conakry, le { moment().format("DD/MM/YYYY") }</p>
                </div>
                
                {/* Pied de page */}
                <footer className="document-footer">
                  <div className='image-left'>
                    <img src={baseURL + currentPaiement.qrcode } alt='qr code' />
                  </div>  
                  <p>DSD Guinée © {moment().format("YYYY")}. Tous droits réservés.</p>
                  <div className='image-right'>
                    <img src={branding} alt='embleme' />
                    <img src={simandou} alt="simadou"/>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      ) : (!isLoading && paiements.length === 0) && (
        <div className='not-found'>
          <BsFillExclamationTriangleFill size={35} color='red'/>
          <h1>Attestation non trouvée</h1>
        </div>
      )}
    </div>  
  );
};

export default Details;